import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { Consultant } from "../types/Consultant";

interface Params extends Omit<Consultant, 'groups'> {
  groups: number[];
}

export const useUpdateConsultantDetails = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Partial<Params>) => {
    return axios.patch(
      `${env.verifyServiceUrl}individual/mandate_consultant/${params.id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
